/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_Tab_CoachInputs */

const en_us2_shell_tab_coach = /** @type {(inputs: Shell_Tab_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainer`)
};

const pt_br2_shell_tab_coach = /** @type {(inputs: Shell_Tab_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal`)
};

const es_419_shell_tab_coach = /** @type {(inputs: Shell_Tab_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenador`)
};

const pt_pt2_shell_tab_coach = /** @type {(inputs: Shell_Tab_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinador`)
};

const fr_fr2_shell_tab_coach = /** @type {(inputs: Shell_Tab_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach`)
};

const de_de2_shell_tab_coach = /** @type {(inputs: Shell_Tab_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach`)
};

const it_it2_shell_tab_coach = /** @type {(inputs: Shell_Tab_CoachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach`)
};

/**
* | output |
* | --- |
* | "Trainer" |
*
* @param {Shell_Tab_CoachInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_tab_coach = /** @type {((inputs?: Shell_Tab_CoachInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Tab_CoachInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_tab_coach(inputs)
	if (locale === "es-419") return es_419_shell_tab_coach(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_tab_coach(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_tab_coach(inputs)
	if (locale === "de-DE") return de_de2_shell_tab_coach(inputs)
	if (locale === "it-IT") return it_it2_shell_tab_coach(inputs)
	return en_us2_shell_tab_coach(inputs)
});
export { shell_tab_coach as "shell.tab_coach" }